import { render } from "./ListeGenrePage.vue?vue&type=template&id=786145a9&ts=true"
import script from "./ListeGenrePage.vue?vue&type=script&lang=ts"
export * from "./ListeGenrePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__